export function responsiveContentfulImage(props: { url: string; w?: number }) {
  const { url, w = 1440 } = props;
  if (!url) return '';
  return `${url}?w=${w.toString()}&q=85&fm=webp`;
}
